import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit form': 'search',
  },

  initialize({ placeholder }) {
    this.listenTo(this.collection, 'filtered', this.clearSearch);
    this.placeholder = placeholder;
  },

  context() {
    return {
      placeholder: this.placeholder,
    };
  },

  clearSearch() {
    this.$('input').val('');
  },

  search(e) {
    e.preventDefault();
    const term = (this.$('input').val() || '').trim();
    if (term.length > 0) {
      this.collection.searchById(term);
    } else {
      this.collection.trigger('filtered');
    }
  },
});



// WEBPACK FOOTER //
// ./app/components/list/search/index.js